import { maxLength, numeric, required } from '@vuelidate/validators'

const validations = {
  pin: {
    required,
    numeric,
    maxLength: maxLength(6),
  },
  reason: { required },
  agb: { required },
}

export default validations
